import { render, staticRenderFns } from "./cadastrador.vue?vue&type=template&id=7ebeb228"
import script from "./cadastrador.vue?vue&type=script&lang=js"
export * from "./cadastrador.vue?vue&type=script&lang=js"
import style0 from "./cadastrador.vue?vue&type=style&index=0&id=7ebeb228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports